import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { ViewProductV2 } from './product-details';
import { CustomerContextProvider } from '../../../context/customer-context';

export function initViewProductV2() {
  document.getElementsByName('view-product-v2').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, productId, locationId, userId, sessionId, isUserLoggedIn, tagDiscount, ...props } =
        Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <CustomerContextProvider>
              <ViewProductV2
                productId={productId}
                locationId={locationId}
                user={{ userId: userId ? userId : undefined, sessionId, isLoggedIn: isUserLoggedIn === '1' }}
                tagDiscount={tagDiscount}
                {...props}
              />
            </CustomerContextProvider>
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
